import { SVGProps } from '../types';

const GooglePayIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M35.6147 18.8403H35.6382L37.5288 14.0952H38.8569L34.7729 23.6079H33.5122L35.0308 20.2798L32.3511 14.0952H33.6792L35.6147 18.8403ZM29.2222 13.8794C30.1255 13.8794 30.8399 14.1257 31.3638 14.6108C31.8876 15.0961 32.145 15.7745 32.145 16.6294V20.7036H30.9761V19.7876H30.9233C30.4147 20.5422 29.7463 20.9194 28.9038 20.9194C28.1903 20.9194 27.5822 20.7042 27.104 20.273C26.6334 19.8724 26.3681 19.2786 26.3833 18.6548C26.3834 17.9694 26.6414 17.4302 27.1499 17.022C27.6585 16.6139 28.3418 16.4136 29.1919 16.4136C29.9206 16.4136 30.5132 16.5522 30.9839 16.814V16.5288C30.9838 16.1053 30.8017 15.7045 30.4829 15.4273C30.1565 15.1347 29.7387 14.9732 29.3062 14.9732C28.6231 14.9732 28.0837 15.2659 27.689 15.8511L26.6108 15.1655C27.1878 14.3108 28.0609 13.8795 29.2222 13.8794ZM23.4302 11.0454C24.2119 11.0301 24.9708 11.33 25.5249 11.8843C26.6334 12.9318 26.7017 14.6964 25.6616 15.8286C25.6162 15.8747 25.5703 15.9212 25.5249 15.9673C24.9556 16.5139 24.2574 16.7914 23.4302 16.7915H21.4106V20.7036H20.188V11.0454H23.4302ZM29.3823 17.4146C28.889 17.4146 28.4712 17.5382 28.1372 17.7769C27.8108 18.0156 27.6431 18.3163 27.6431 18.6782C27.6431 19.0015 27.7952 19.302 28.0454 19.4868C28.3186 19.7024 28.6531 19.8176 28.9946 19.8101C29.5109 19.8101 30.0052 19.6026 30.3696 19.2329C30.772 18.8479 30.977 18.3933 30.9771 17.8696C30.5974 17.5617 30.0656 17.4069 29.3823 17.4146ZM21.4106 15.605H23.4604C23.916 15.6204 24.3571 15.4352 24.6685 15.104C25.306 14.4339 25.2908 13.3554 24.6304 12.7085C24.319 12.4004 23.9009 12.231 23.4604 12.231H21.4106V15.605Z"
      fill="#3C4043"
    />
    <path
      d="M17.1905 15.9438C17.1905 15.5664 17.1601 15.189 17.0994 14.8193H11.9443V16.9529H14.8977C14.7762 17.6384 14.3814 18.2546 13.8044 18.6397V20.0262H15.5658C16.5983 19.0634 17.1905 17.6384 17.1905 15.9438Z"
      fill="#4285F4"
    />
    <path
      d="M11.9447 21.3664C13.4176 21.3664 14.6627 20.8734 15.5662 20.0262L13.8048 18.6397C13.3113 18.9786 12.6812 19.1712 11.9447 19.1712C10.5174 19.1712 9.31025 18.193 8.8775 16.8835H7.06299V18.3162C7.98923 20.1879 9.87966 21.3664 11.9447 21.3664Z"
      fill="#34A853"
    />
    <path
      d="M8.87746 16.8836C8.64966 16.198 8.64966 15.4509 8.87746 14.7577V13.3327H7.06266C6.28055 14.8963 6.28055 16.7449 7.06266 18.3085L8.87746 16.8836Z"
      fill="#FBBC04"
    />
    <path
      d="M11.9447 12.47C12.7267 12.4546 13.4783 12.755 14.0401 13.3019L15.6041 11.7152C14.6095 10.7755 13.3037 10.2594 11.9447 10.2748C9.87966 10.2748 7.98923 11.461 7.06299 13.3327L8.8775 14.7654C9.31025 13.4482 10.5174 12.47 11.9447 12.47Z"
      fill="#EA4335"
    />
  </svg>
);

export { GooglePayIcon };
